"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateColorThemeValues = void 0;
var generation_1 = require("../generation");
// TODO: https://github.com/salute-developers/plasma/issues/512
/**
 * Генерация тем на основе объекта.
 * @param {Record<string, TokenDataGroup<string>>} colorThemes Объект с темами
 * @return {GeneratedFiles}
 */
var generateColorThemeValues = function (colorThemes) {
    var out = [];
    for (var _i = 0, _a = Object.entries(colorThemes); _i < _a.length; _i++) {
        var _b = _a[_i], name_1 = _b[0], themeItem = _b[1];
        out.push({ file: "".concat(name_1, ".ts"), content: (0, generation_1.generateTokens)(themeItem) });
    }
    return out;
};
exports.generateColorThemeValues = generateColorThemeValues;
//# sourceMappingURL=generateColorThemeValues.js.map